import { useMemo } from 'react';

export const useSortedAnswerOptions = (options: Record<string, unknown>[]) =>
  useMemo(() => {
    return options.sort(
      (a, b) => Number(a.option_type) - Number(b.option_type)
    );
  }, [options]);
